module.exports = __webpack_public_path__ + "img/service_avatar.1c6ab2dd.jpeg";